import type { Modification } from '@carboncopyco/types';
import { array, boolean, mixed, object, string } from 'yup';

export const selectorsSchema = array()
  .of(object())
  .min(1)
  .label('Selectors')
  .required()
  .strict()
  .json()
  .typeError('Invalid Selectors JSON');

export const contentReplaceModifiersSchema = array()
  .of(
    object({
      type: string().oneOf(['ContentReplace']).required(),
      applyTo: string().oneOf(['response']).required(),
      arguments: object().when('type', {
        is: 'ContentReplace',
        then: (schema) =>
          schema.shape({
            match: string().required(),
            replace: string().required(),
            mode: string(),
            caseSensitive: boolean(),
          }),
      }),
    })
  )
  .required()
  .strict()
  .json()
  .typeError('Invalid Content Replace Modifier JSON');

export const modifiersSchema = array()
  .of(
    object({
      type: string().required(),
      applyTo: string().required(),
      arguments: object().required(),
    })
  )
  .min(1)
  .required()
  .strict()
  .json()
  .typeError('Invalid Custom Modifier JSON');

export const responseSchema = mixed().label('New Response');

export const responseTypeSchema = string()
  .oneOf(['static', 'dynamic', 'custom'])
  .label('Response Type')
  .typeError('Invalid Response Type')
  .required();

export const responseRepresentationTypeSchema = string()
  .oneOf(['raw', 'form'])
  .label('Response Representation Type')
  .typeError('Invalid Response Representation Type')
  .required();

export const ruleNameSchema = (
  transactionModifications: Modification<'transaction_rule'>[]
) =>
  string()
    .max(100)
    .label('Rule Name')
    .required()
    .trim()
    .test(
      'maxOneRuleNameMatch',
      'Rule name already exists',
      (name) =>
        !transactionModifications?.some(({ content }) => {
          return content.name === name;
        })
    );

export const ruleDescriptionSchema = string().max(500).label('Description');

export const headersSchema = array()
  .of(
    object()
      .shape({
        name: string().required(),
        value: string().min(0),
      })
      .strict()
  )
  .label('Headers')
  .optional()
  .typeError('Invalid Headers');
